export default "__VITE_ASSET__BH2kMfI9__"